import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

export default function Modal({ title, onClose, children }) {
  const ref = useRef();
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const dialog = ref.current;
    const previous = document.activeElement;
    dialog.showModal();
    return () => {
      dialog.close();
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  return (
    <dialog
      ref={ref}
      className="cb-dialog"
      aria-labelledby="ted-dialog-title"
      onCancel={(event) => {
        event.preventDefault();
        close.current();
      }}
    >
      <div className="cb-dialog__header">
        <h2 id="ted-dialog-title">{title}</h2>
        <button
          type="button"
          className="cb-icon-button"
          aria-label="Close dialog"
          onClick={onClose}
        >
          ×
        </button>
      </div>
      {children}
    </dialog>
  );
}
Modal.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};
